module.exports = __webpack_public_path__ + "img/leftSide.6af98bc2.png";